/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 10/23/2023
 */
import React,{useState,useEffect} from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Stack
} from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline"
import NotInterestedIcon from "@mui/icons-material/NotInterested"
import Helpers from '../../../../base/utils/Helpers'
import api from "../../../../base/services/ResApi"
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling"
import Alerts from '../../../../base/errorHandeling/Alerts'

import broadcastingInProgressBig from "../../../../../resources/broadcastingInProgressBig.gif"
import broadcastingNewBig from "../../../../../resources/broadcastingNewBig.gif"
import broadcastingCompletedBig from "../../../../../resources/broadcastingCompletedBig.gif"
import broadcastingRetryBig from "../../../../../resources/broadcastingRetryBig.gif"
import broadcastingstoppedBig from "../../../../../resources/broadcastingstoppedBig.gif"
import broadcastingStartBig from "../../../../../resources/broadcastingStartBig.gif"



const BroadcastingModal = ({
  open,
  onClose,
  deployStatus,
  groupId,
  setUpdateData,
}) => {
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  const [iserror, setIserror] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  const [iserrorShow, setIserrorShow] = useState(false)
  const [broadcastIcon, setBroadcastIcon] = useState(broadcastingNewBig)

  useEffect(() => {
    if (deployStatus === "IN_PROGRESS") {
      setBroadcastIcon(broadcastingInProgressBig)
    } else if (deployStatus === "NEW") {
      setBroadcastIcon(broadcastingNewBig)
    } else if (deployStatus === "COMPLETED") {
      setBroadcastIcon(broadcastingCompletedBig)
    } else if (deployStatus === "RETRY") {
      setBroadcastIcon(broadcastingRetryBig)
    } else if (deployStatus === "STOP") {
      setBroadcastIcon(broadcastingstoppedBig)
    } else if (deployStatus === "START") {
      setBroadcastIcon(broadcastingStartBig)
    }
  }, [])

  const broadcastAction = (type) => {
    let Config = {
      headers: {
        "Deploy-Status": type,
      },
    }
    api
      .patch("/sse/control/broadcast/" + groupId, {}, Config)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setIserrorShow(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setTimeout(() => {
          setUpdateData(true)
          setIsSuccess(false)
          setSuccessMessages([""])
          onClose()
        }, 3000)
      })
      .catch((error) => {
        setIsSuccess(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        )
        setTimeout(() => {
          setIserror(false)
          setErrorMessages([""])
          onClose()
        }, 4000)
      })
  }

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={open}
        PaperProps={{ style: { borderRadius: "10px" } }}
      >
        <DialogTitle sx={{ bgcolor: "#116c6f", color: "white" }}>
          Broadcast Action
        </DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          dividers
        >
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <img src={broadcastIcon} alt="Profile" />
          <span style={{ color: "#C7C7C7" }}>
            Deploy Status: {Helpers.replaceUnderscoresWithSpaces(deployStatus)}
          </span>
          <br />
          <span>Are you sure you want to proceed?</span>
        </DialogContent>

        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose} variant="outlined" color="error">
            Cancel
          </Button>

          <LoadingButton
            onClick={() => broadcastAction("START")}
            color="success"
            variant="contained"
            loadingPosition="start"
            startIcon={<PlayCircleOutlineIcon />}
          >
            Start
          </LoadingButton>

          <LoadingButton
            onClick={() => broadcastAction("STOP")}
            color="error"
            variant="contained"
            loadingPosition="start"
            startIcon={<NotInterestedIcon />}
          >
            Stop
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default BroadcastingModal